import { Typography, TypographyProps } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { cn } from "../../../../../helpers/cn";

export const ListingModalLoginSeparator = () => {
  return (
    <ListingModalLoginSeparatorWrapper>
      <ListingModalLoginSeparatorLine />
      <ListingModalLoginSeparatorTitle>Or</ListingModalLoginSeparatorTitle>
      <ListingModalLoginSeparatorLine />
    </ListingModalLoginSeparatorWrapper>
  );
};

type ListingModalLoginSeparatorWrapperProps = React.ComponentProps<"div">;

export const ListingModalLoginSeparatorWrapper = ({
  className,
  children,
  ...props
}: ListingModalLoginSeparatorWrapperProps) => {
  return (
    <div
      className={cn(
        "w-full flex items-center justify-center space-x-[20px]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

type ListingModalLoginSeparatorLineProps = React.ComponentProps<"div">;

export const ListingModalLoginSeparatorLine = ({
  className,
  ...props
}: ListingModalLoginSeparatorLineProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <div
      style={{
        backgroundColor: colors.surface.onSurface,
      }}
      className={cn("w-[86px] h-[1px]", className)}
      {...props}
    />
  );
};

type ListingModalLoginSeparatorTitleProps = TypographyProps;

export const ListingModalLoginSeparatorTitle = ({
  children,
  className,
  sx,
}: ListingModalLoginSeparatorTitleProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Typography
      sx={{
        color: colors.surface.onSurface,
        ...sx,
      }}
      className={cn("font-normal text-[14px]", className)}
    >
      {children}
    </Typography>
  );
};
